module.exports = new __parcel__URL__("icon-1.aab9efc5.svg").toString();